export const SITE_NAME = "Flake.art";
export const APP_NAME = "Flake.Art";
export const APP_URL = "https://flake.art";
export const CONTACT_EMAIL = "support@flake.art";
export const INFURA_KEY = "f6d110a8a5904705b2eb97815ba53e85";
export const API_URL = "https://flake.art/api";